import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { ISyncSingleUserVm } from '../sync-single-user-vm.model';
import { ISyncUserByEmailIm } from '../sync-user-by-email-im.model';
@Injectable({ providedIn: 'root' })
export class SyncUserQuestionsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/SyncUserQuestions`;
  }
  post(input: ISyncUserByEmailIm): Observable<ISyncSingleUserVm> {
    const headers = this.createHeaders();
    return this.http.post<ISyncSingleUserVm>(this.baseUrl, input, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
